import "./MiniNav.css";

const MiniNav = () => {
  return (
    <nav className="mini-nav">
      <ul>
        <li>
          <a href="/">Features</a>
        </li>
        <li>
          <a href="/">About</a>
        </li>
        <li>
          <a href="/">Connect</a>
        </li>
        <li>
          <a href="/">Download</a>
        </li>
      </ul>
    </nav>
  );
};

export default MiniNav;
